import util from '@bmp-vue/core/api/util'

const controller = 'CobrancaRecorrente'

export default Object.assign({}, util.GetCrud(controller, ['getall', 'get', 'post', 'put', 'persist']), {
})
